import { useCallback } from 'react';
import { FifthDoorContent } from 'shared/components/FifthDoorContent';
import { useAppDispatch } from 'shared/hooks';
import { setModalContent, setPredictionVisible } from 'shared/slices';
import { TDoor } from 'shared/types/doors';

export const FifthDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const dispatch = useAppDispatch();

  const handleClickBtn = useCallback(async () => {
    dispatch(setModalContent(null));

    dispatch(setPredictionVisible(true));
  }, [dispatch]);

  return <FifthDoorContent onClickBtn={handleClickBtn} {...props} />;
};
